import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { RecSearchService } from '../../rec-search-service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { NgForm, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DocCategoryVsComponent } from '../../../shared/components/doc-category-vs/doc-category-vs.component';
import { AmountrangeComponent } from '../../../shared/components/amountrange/amountrange.component';
import { DaterangeComponent } from '../../../shared/components/daterange/daterange.component';
import { CityTownEXComponent } from '../../../shared/components/city-town-ex/city-town-ex.component';
import * as DateRangeActions from './../../../store/actions/daterange.action';
import * as AmountActions from './../../../store/actions/amountrange.action';
import * as CityActions from './../../../store/actions/citytown.action';
import * as DocCategoriesActions from './../../../store/actions/doccategories.action';
import { DateRangeParentComponent } from '../../../shared/components/date-range-parent/date-range-parent.component';


@Component({
  selector: 'app-rec-value-search',
  providers: [RecSearchService],
  templateUrl: './rec-value-search.component.html',
  styleUrls: ['./rec-value-search.component.css']
})
export class RecValueSearchComponent implements OnInit {

  @ViewChild(CityTownEXComponent, { static: false }) cityTownChild;
  //@ViewChild(DaterangeComponent) dateRangeChild;
  @ViewChild(DateRangeParentComponent, { static: false }) dateRangeChild;
  @ViewChild(AmountrangeComponent, { static: false }) amountRangeChild;
  @ViewChild(DocCategoryVsComponent, { static: false }) docCategoryVsChild;

  @ViewChild('f', { static: true }) recValueSearchForm: NgForm;
  parentForm: UntypedFormGroup;
  screenWidth: any;

  constructor(private router: Router, private service: RecSearchService, private store: Store<AppState>, private fb: UntypedFormBuilder) {


  }

  ngOnInit() {
    this.parentForm = this.fb.group({
      //compoundName: this.fb.group({
      //  lastcorpName: ['', Validators.required],
      //  fName: ['']
      //})
    });

    //this.recValueSearchForm.form = this.fb.group({});
    //this.getScreenSize();
    //this.dateRangeChild.utilityobj.fromDate = '1/1/1962';
    //this.dateRangeChild.utilityobj.toDate = '12/31/2020';
  }

  addRecToStore(fromamount, toamount, fromdate, todate, citytowns, doccategory) {
    this.store.dispatch(new AmountActions.AddAmount({
      type: this.amountRangeChild.utilityobj.type,
      fromAmount: fromamount,
      toAmount: toamount
    }));


    this.store.dispatch(new DateRangeActions.AddDate({
      fromDate: fromdate,
      toDate: todate
    }));

    this.store.dispatch(new CityActions.AddCity({
      citytowns: citytowns
    }));

    this.store.dispatch(new DocCategoriesActions.AddDocCategories(
      doccategory
    ));
  }

  delRecFromStore(index) {
    this.store.dispatch(new AmountActions.RemoveAmount(index));
    this.store.dispatch(new DateRangeActions.RemoveDate(index));
    this.store.dispatch(new CityActions.RemoveCity(index));
    this.store.dispatch(new DocCategoriesActions.RemoveDocCategories(index));
  }

  search(url) {

    //this.delRecFromStore(0);

    //this.addRecToStore('', '', this.dateRangeChild.utilityobj.fromDate, this.dateRangeChild.utilityobj.toDate, '', this.cityTownChild.utilityobj.citytowns, this.docTypeChild.utilityobj.doctypes, this.compoundAddressChild.utilityobj.streetNumber, this.compoundAddressChild.utilityobj.streetAddress, '', '', '');

    this.router.navigate([url]);

  }

  onSubmit(e) {
    if (this.recValueSearchForm.valid) {

      this.delRecFromStore(0);
      this.addRecToStore(
        this.amountRangeChild.utilityobj.fromAmount,
        this.amountRangeChild.utilityobj.toAmount,
        this.dateRangeChild.utilityobj.fromDate,
        this.dateRangeChild.utilityobj.toDate,
        this.cityTownChild.utilityobj.citytowns,
        this.docCategoryVsChild.DocCategories
      );
      //console.log(`docCats in RegValueSearch: ${JSON.stringify(this.docCategoryVsChild.DocCategories)}`);
      //console.log(`this.cityTownChild.utilityobj.citytowns: ${JSON.stringify(this.cityTownChild.utilityobj.citytowns)}`);
      this.router.navigate(['/rec-value-result-pg']);

    }
    else {
      this.validateAllFormFields(this.recValueSearchForm.form);
    }
  }



  validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  ngAfterViewInit() {

    this.recValueSearchForm.form = this.fb.group({});
    this.getScreenSize();
    this.dateRangeChild.utilityobj.fromDate = '1/1/1962';
    this.dateRangeChild.utilityobj.toDate = '12/31/2020';

    this.recValueSearchForm.form.addControl('amountRangeForm', this.amountRangeChild.form);
    this.amountRangeChild.form.setParent(this.parentForm);

    this.recValueSearchForm.form.addControl('dateRangeForm', this.dateRangeChild.form);
    this.dateRangeChild.form.setParent(this.recValueSearchForm.form);
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

}
